import { getQueryString } from '@libraries/common/stringUtils';

export const openMessageWindow = (targetUserUuid?: string) => {
  const queryString = getQueryString({ targetUserUuid });
  window.open(
    `/user/messages${queryString ? `?${queryString}` : ''}`,
    '',
    'width=1024,height=768',
  );
};
